import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import { FAIcon } from './FAIcon'
import _ from 'common-tools/LodashHelper'

import styles from './DataGrid.less'

export class DataGrid extends React.Component {
  static pt = {
    data: pt.array,
    renderDataItem: pt.func.isRequired,
    onLoadMore: pt.func,
    loading: pt.bool.isRequired,
    cardStyles: pt.string.isRequired,
    children: pt.any
  }

  static defaultProps = {
    loading: false,
    cardStyles: 'Auto' // Fixed, Fluid, Auto
  }

  renderLoadMore (results, loading) {
    const { onLoadMore } = this.props

    if (_.isArray(results) === false) {
      return null
    }

    return <div className={styles.loadMore}>
      {loading
        ? <FAIcon name='spinner' spin size='24px' toolTip='Loading...' className='menu' overlayClassName='menu' />
        : <FAIcon name='chevron-down' size='24px' toolTip='Load More' className='menu' overlayClassName='menu' onClick={onLoadMore} />
      }

    </div>
  }

  render () {
    const { data, hasMore, renderDataItem, cardStyles, children, loading } = this.props
    let items = _.compact(_.map(data || [], (a, i) => { return renderDataItem(a, i, (data || []).length) }))

    let cardStyle = cardStyles
    if (cardStyles === 'Auto') {
      cardStyle = items.length < 5 ? 'Fixed' : 'Fluid'
    }

    if (loading & items.length === 0) {
      return <div className={styles.loadMore}>
        <FAIcon name='spinner' spin size='24px' toolTip='Loading...' className='menu' overlayClassName='menu' />
      </div>
    }

    return (
      <React.Fragment>
        <div className={styles[`datagrid${cardStyle}`]}>
          {items.length > 0
            ? items
            : children
          }
        </div>
        {hasMore
          ? this.renderLoadMore(data, loading)
          : null
        }
      </React.Fragment>
    )
  }
}
